import {Component, Input, OnInit} from '@angular/core';
import {ModalController, Platform} from '@ionic/angular';
import {DocumentModel} from '../../models/document.model';
import {DrawSignaturePage} from '../../modals/draw-signature/draw-signature.page';
import {ScreenOrientation} from '@ionic-native/screen-orientation/ngx';

@Component({
    selector: 'simple-signature',
    templateUrl: './simple-signature.component.html',
    styleUrls: ['./simple-signature.component.scss'],
})
export class SimpleSignatureComponent implements OnInit {
    @Input() document: DocumentModel;
    @Input() title: string;

    constructor(private modalController: ModalController,                
        private screenOrientation: ScreenOrientation,
        private plt: Platform,) {
    }

    ngOnInit() {
    }

    async openModalDrawSignature() {
        //if (this.plt.is('cordova')) {
        //    this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.LANDSCAPE);
        //}
        const modal = await this.modalController.create({
            component: DrawSignaturePage,
            cssClass: 'modal-fullscreen',
            componentProps: {
                'document': this.document
            }
        });

        modal.onDidDismiss().then((dataReturned) => {
            if (dataReturned.data) {
                if (this.title === 'Signature') {
                    this.document.signature = dataReturned.data;
                }
                if (this.title === 'Engineer Signature') {
                    this.document.engineerSignature = dataReturned.data;
                }
            }
        });
        return await modal.present();
    }

}
